module.exports = {
    title: "サプライチェーンパートナー大会",
    menu: {
        menu: "トップページ",
        guest: "出席心得",
        agenda: "大会スケジュール",
        meetingS: "お食事",
        new: "新車見学",
        new1: "新車見学アンケート調査",
        live: "现场直播",
        photo: "素晴らしい瞬間",
        investigation: "アンケート調査",
        meetingL: "会議資料",
        contact: "お問い合わせ",
        service: '送迎サービス',
    },
    menuCn: {
        menu: "首页",
        guest: "参会须知",
        agenda: "大会スケジュール",
        meetingS: "会议查询",
        photo: "图片视频",
        investigation: "问卷调查",
        meetingL: "会议资料",
        contact: "联系我们"
    },
    welcome: {
        welcome: "ウェルカム",
        signOut: "ログアウト"
    },
    login: {
        code: "検証コードをご記入ください",
        phone: "携帯番号をご記入ください",
        country: "携帯番号をご記入ください",
        getCode: "検証コード送信",
        loginBtn: "ログイン",
        title: "情報を検証します",
    },
    tips: {
        phone_type: "中国大陸の番号のみ対応できます",
        phone: "携帯番号をご記入ください",
        phone_err: "携帯番号の様式は正しくありません",
        code: "検証コードをご記入ください",
        code_err: "検証コードは正しくありません",
        code_success: "検証コードをお送りいたしました",
        code_error2: "すべての情報をご記入ください",
        loginPlease: "先にログインしてください",
        loginSuccess: "ログイン成功",
        completePlease: "すべての情報をご記入ください",
        tips1: "お知らせ",
        tips2: "確認",
        l_tips1: "該当する情報はありません",
        l_tips11: "ユーザーが存在しません",
        l_tips2: "検証コードの入力は正しくありません",
        l_tips3: "パラメータエラー",
        l_tips4: "再提出をしないでください",
        l_tips5: "授権失敗",
        l_tips6: "発信が頻繁におこる。あらためてトライしてください",
    },
    back: {
        waiting: "お楽しみにしてください",
        welcome: "ウェルカム，",
        login_err: "ログイン失効",
        sure: "確認",
        cancle: "取り消し",
        success: "成功",
        success_text1: "情報のご提出ありがとうございます",
        success_text2: "",
        btn: "会議情報をチェックする",
        title: "東風日産サプライヤー大会サービスデスク",
        close: "機能しない"
    },
    guest: {
        title: "出席心得",
        menu1: "受付事項",
        menu2: "顔識別",
        menu3: "同時通訳の案内",
        menu4: "ホテルマップ",
        menu5: "チェックアウトについて",
        menu55: "＆領収書",
        menu6: "領収書受取",
        signin: {
            title: "受付事項",
            title1: "受付時間及び場所：",
            date1: "2024年12月25日",
            time1: " 12:00-24:00",
            time2: "広州番禺長隆ホテルロビー",
            time22: "",
            date2: "2024年12月26日",
            time3: " 08:00-13:00",
            time4: "お泊りになる方：広州番禺長隆ホテルロビー",
            time44: "お泊りにならない方：広州番禺国際会展中心",
            time444: "長隆国際会展センターの隣の駐車場",
            place1: "受付担当窓口（直接……にご連絡ください）",
            place11: "受付連絡先（直接……にご連絡ください）",
            title2: "受付プロセス：",
            procedure1: 'お客様は顔認証或いは携帯番号で受付けをすることが出来ます。情報が確認出来たら、客室番号とお客様カードをお受け取り、ホテルのフロントへ身分証明書のご提示の後、ルームカードをお受け取り、チェックイン完了となります。',
            title3: "送迎案内：",
            tips11: "1.お出迎え時間：<br>12月18日 12:00-24:00<br>12月19日 07:00-12:00",
            tips1: '2.広州白雲空港、広州北鉄道駅それぞれ送迎を用意いたします。出口にて「東風日産」のネームプレートを持ちながらお待ちしております。スタッフにフォローしてご乗車ください。',
            tips2: "3.広州白雲空港連絡先（直接……にご連絡ください）：周裕",//137 1463 8120
            tips3: "広州北鉄道駅連絡先（直接……にご連絡ください）：劉淑儀",
            contact: {
                name: "ホテルロビー：熊娟",
                name1: "国際会展中心：劉婷",
            },
        },
        face: {
            title: "顔識別",
            tips1: "1.大会は全面的に顔識別システムを利用しています。受付、会場、レストランの出入り、新車見学は顔識別が利用できます。　顔を認証カメラに向かっていただいて結構です。",
            tips2: "2.ゲストパスはご来賓の皆様が会場、レストランの出入りのための身分補充証明になるので必ず持参してください。転用不可。",
        },
        earphone: {
            title: "同時通訳の案内",
            tips_title: "同時通訳のご利用案内：",
            tipss: 'お願い：会議終了後、会場を出てから「同時通訳イヤホン回収所」へご返却ください。万が一紛失や破損の場合は求償させて頂きます（システムにて管理）。', step1: "ステップ1",
            tips1: "イヤホンを受信機のイヤホンポートに差し込んでください",
            step2: "ステップ2",
            tips2: "受信機の電源をオンしてください（ご注意：イヤホンを差し込まない限り、電源がオンできません）",
            step3: "ステップ3",
            tips3: "ボタンを押しながら声が聞こえるまでチャネルをチューニングしてください。自分のニーズに合わせてボリュームを調整してください。以上の操作で依然声がお聞こえにならない方は会場外までお越しいただきスタッフまでお問い合わせください。",
        },
        hotel: {
            title: "ホテルマップ",
            tips1: "ホテル平面図",
            tips2: "会場内平面図",
            tips3: 'ホテル群平面図',
            title1: "STEIGENBERGER Hotel Guangzhou Daguan 1F",
            title2: "STEIGENBERGER Hotel Guangzhou Daguan 2F",
            title3: "Sunac STEIGENBERGER Hotel Guangzhou",
        },
        out: {
            title: "チェックアウトについて",
            tips1: {
                title: "チェックアウトについて",
                one: "1、チェックアウトの当日は12：00迄に部屋の鍵をフロントにご返却ください。",
                two: "2、レートチェックアウトの場合はロビーの受付所へお申し込みください。ホテルはお客様のチェックアウト予定時間に合わせて部屋を掃除致します。12:00－18:00のチェックアウトは半日分のルーム代、18:00以降は一日分のルーム代が発生します。",
                three: "3、宿泊費はお客様の宿泊要否の回答により前払いが発生する為、お申し込み後のキャンセルの場合は宿泊費の返金が出来かねます。",
                three11: "4、以下の場合はフロントへのご自払いをお願い致します：",
                three1: "①部屋に物の破損が発生した場合",
                three2: "②その他の消費があった場合",
                three3: "③ホテルのルームカードを紛失した場合、料金50元/枚が発生します。",
                four: "5、チェックアウト後、忘れ物がある場合、受付担当者にご連絡ください。",
                four1: "熊娟"
            },
            tips2: {
                title: "領収書受取",
                tips1: "領収書発行日",
                tips2: "2024年12月25日ホテルチェックイン後、12月27日チェックアウト前。　",
                tips3: "領収証（発票）の取得",
                tips4: "（支払い）レシートを持って長隆ホテルのフロントで領収証（発票）をご申請ください。ホテルはe-mailの形で電子領収証を送信します。領収証発行代行が必要な場合は、事前にレシートの提出が必要です。",
            },
            tips3: {
                title: "お願い",
                one: "チェックアウトのピーク時に領収証（発票）申請の待ち時間が長くなる恐れがありますので、余裕を持って事前に申請に行くことをお勧めい致します。",
                two: "ご事情により、当日ご対応できない場合、事前に受付所の係員（",
                three: '）迄お申し込みください。別途メール送信致します。',
            },
        },
        timetable: {
            title: "送迎サービス",
            title1: "お出迎えについて",
            place1: {
                name: "広州番禺長隆ホテル - 広州白雲空港",
                time1: "06:00　07:00　07:30　08:00　08:30",
                time2: "09:00　10:00　11:00　12:00　13:00　14:00"
            },
            place2: {
                name: "広州番禺長隆ホテル - 広州南駅",
                time1: "08:00　09:00　10:00　11:00",
                time2: "12:00　13:00　14:00",
            },
            tips1_title: "12月27日帰途送迎フライト/汽車時刻表",
            contact: {
                name: "広州白雲空港連絡先（直接……にご連絡ください）：周裕",
                name1: "広州南駅連絡先（直接……にご連絡ください）：葉趣煥",
                name2: "周裕",
            },
            place: {
                title: "待ち合わせ場所",
                name: "広州番禺長隆ホテルロビー"
            },
            tips: {
                title: "お知らせ：",
                one: "1、ホテルから広州白雲国際空港までの所要時間は約70分です。飛行機離陸3.5時間前にホテルから出発することをお勧め致します。",
                two: "2、ホテルから広州南駅までの所要時間は約30分です。列車発車2時間前にホテルから出発することをお勧め致します。",
                three: "お願い:",
                four: "ご乗車の方々が時間通り空港／鉄道駅に到着するため、各バスは上記時間厳守で発車いたします",
                five: '広州南駅にご到着後、東広場のインフォメーションカウンター迄ご参集ください。',
                six: '1、広州白雲空港、広州南駅にてお出迎えサービスを提供しております。出口で「東風日産」看板をお持ちした係員が乗車案内致します。',
                seven: '2、お出迎え時間：',
                seven1: '12月25日 12:00-24:00',
                seven2: '12月26日 08:00-12:00',
                eight1: '広州白雲空港連絡先（直接……にご連絡ください）：周裕',
                eight2: '広州南駅連絡先（直接……にご連絡ください）：葉趣煥',
            }
        }
    },
    agenda: {
        title: "大会スケジュール",
    },
    meetingS: {
        title: "会議案内",
        menu1: "サブテーマ検索",
        menu2: "宴会検索",
        theme: {
            title: "サブテーマ検索",
            title1: "サブテーマ",
            tips: "ご参加予定のサブテーマ",
            tips1: "ご参加予定のサブテーマ",
            thead: {
                td1: "日付",
                td2: "新車体験・評価の予約",
                td22: "残りの枠",
                td3: "場所",
                td4: "テーブル番号",
            },
            date: "12月26日",
            none: 'No',
            meet: "MEET大講堂",
            meet_place: "会展中心宴会ホール",
            g30: "G30 Supplier Summit",
            g30_place: "会展中心宴会ホール",
            finance: "Financial",
            finance_place: "Chimelong International Cnvention Center 3F 321",
            btn: "検索",
            placeholder: "ゲストの氏名或いは携帯番号をご入力ください。",
            map_text: "大会席順のレイアウト図",
            areaName: "",
            query_tips: "请选择品鉴时间预约",
            query_tips1: "ゲストの氏名或いは携帯番号をご入力ください。",
            query_tips_none: "該当する情報はありません"
        },
        yhquery: {
            title: "宴会検索",
            query_tips: "ゲスト名ご入力",
            thead: {
                td1: "氏名",
                td2: "時間/場所",
                td3: "テーブル番号"
            },
            results: "検索結果",
            guest: "同席ゲスト"
        }
    },
    meetingL: {
        file1: "DNEC rport",
        file2: "PURCH Division report",
        file3: "MQA report",
        file4: "SCM report",
        file5: "S & M Division report",
        file6: "Dongfeng Venucia report",
        file7: "Dongfeng Infiniti report",
        tips1: "可点击图片放大",
        loading: "Loading"
    },
    photo: {
        title: "素晴らしい瞬間",
        menu1: "大会写真",
        menu2: "ビデオ抜粋",
        menu3: "大会へのメッセージ",
    },
    investigation: {
        title: "出席者満足度調査表",
        user: "ご来賓の皆様：",
        tips: "2024年サプライチェーンパートナー大会をお越しいただきまして誠にありがとうございます。サービス向上のための取り組みの一環として、大会を出席されている方々に、満足度やご意見を調査する「出席者満足度調査」を実施しています。本調査は、無記名方式にて行います。下表の項目により、実際の参加体験に対し、評価するようお願い致します。ご要望・ご意見は、会議サービスの向上や改善に役立てております。",
        select1: "A  満足",
        select2: "B  普通",
        select3: "C  不満足",
        question1: "1. 今回大会の全体の段取り：",
        question2: "2. ホテルの宿泊、食事の段取り：",
        question3: "3. 受付、チェックインの対応速度：",
        question4: "4. 出迎えの段取り、サービス態度(出迎えを選でいない方は記入不要)：",
        question5: "5. オンライン申し込みシステム：",
        question6: "6. WeChatオフィシャルアカウントの使用と機能：",
        question7: "7. 会議案内、受付の態度および協力度：",
        question8: "8、イベントのテーマ、アジェンダ及び内容に対して",
        question9: "9. 会務スタッフに対する全体評価：",
        question10: "10. ほかのご要望・ご意見：",


        thanks: "ご協力ありがとうございます！",
        btn: "提出",
        success: "ご協力ありがとうございます！",
        already: "再提出をしないでください。",
    },
    investigation1: {
        tips: "評価ルール：1〜2点 - 非常に醜い、3〜4点 - あまり好きではない、5〜6点 - 普通、7〜8点 - 比較的に好き、9〜10点 - 非常に好き",
        question1: "1、外観：",
        question2: "2、内装：",
        question3: "3、N7が大ヒットするために、どのような取り組みを行うべきだと思いますか？製品/価格/マーケティング/宣伝/サービスなどの具体的なアイデアをお書きください。",
        placeholder: '「具体的な不満点を教えてください」と自動的に表示されますので、今後の「改善」のためにご協力賜りますようお願い申し上げます',
        question1Arr: [{
            name: '【フロントのデザイン】',
            val: 'q1'
        }, {
            name: '【側面のデザイン】',
            val: 'q2'
        }, {
            name: '【リアのデザイン】',
            val: 'q3'
        }, {
            name: '【全体の外観デザイン】',
            val: 'q4'
        }, {
            name: '【好きな車体色を2〜3色ご記入ください】',
            val: 'q5',
            type: 'input'
        }],
        question2Arr: [{
            name: '【センターコンソール/インストパネル】',
            val: 'q6'
        }, {
            name: '【四ドアの内装】',
            val: 'q7'
        }, {
            name: '【センターアームレストのデザイン】',
            val: 'q8'
        }, {
            name: '【シートのデザイン】',
            val: 'q9'
        }, {
            name: '【スペース/快適さ】',
            val: 'q10'
        }, {
            name: '【全体の内装】',
            val: 'q11'
        }, {
            name: '【好きな内装色を2〜3色ご記入ください】',
            val: 'q12',
            type: 'input'
        }],
        thanks: "ご協力ありがとうございます！",
        btn: "提出",
        success: "ご協力ありがとうございます！",
        already: "再提出をしないでください。",
        required_tip: "{name}の採点をお願いします",
        reason_required_tip: "「具体的な不満点を教えてください」と自動的に表示されますので、今後の「改善」のためにご協力賜りますようお願い申し上げます",
        suggestion_required: "N7が大ヒットするために、どのような取り組みを行うべきだと思いますか？",
        submit_success: "成功",
        submit_error: "提出に失敗しましたら,後ほど再試行をお願いします"
    },
    contact: {
        tips: "活動期間中、質問があれば下記担当者にご連絡ください。",
        thead: {
            td1: "会務主管",
            td2: "氏名",
            td3: "電話番号",
            td4: "conference affairs",
        },
        job: "Director",
        job1: "coordinator",
        tbody: {
            line1: {
                job: "総統括",
                name: "朱俊",
                name1: "鄧紅梅",
            },
            line2: {
                job: "大会お問い合わせ",
                name: "陳菁"
            },
            line3: {
                job: "内部調整",
                name: "岳宇"
            },
            line4: {
                job: "会場総統括",
                name: "許文凱",
                name1: "陳偉龍"
            },
            line5: {
                job: "車輌総統括",
                name: "鄧紅梅"
            },
        }
    },
    video: "ビデオ-",
    say: {
        title: '大会へのメッセージ',
        bth: 'メッセージ入力',
        placeholder: '20文字以内',
        tips: 'メッセージ入力',
    },
};


// WEBPACK FOOTER //
// ./src/i18n/jp.js